import React, { memo } from 'react';
import { useSelector } from 'react-redux';

import TooltipIcon from '@/views/components/TooltipIcon/TooltipIcon';

const LettersContainerHeader = () => {
	const { dict } = useSelector((state) => state.app);

	return (
		<div className='table__header-container'>
			<div className='table__item head'>
				<div className='table__item--col head'>
					{dict.letters.table.title.toUpperCase()}&nbsp;
					<TooltipIcon 
						tooltipText={ "Rodzaje tytułów: <b>PIERWOTNY</b> (oryginalny), <b>NADANY</b> (zmieniony przez wprowadzającego) i <b>INCIPIT</b> (tytuł nie został podany, więc jest nim pierwsza fraza w piśmie)." } 
					/>
				</div>
				<div className='table__item--col head'>
					{dict.letters.dept.toUpperCase()}
				</div>
				<div className='table__item--col head'>
					{dict.letters.table.editDate.toUpperCase()}
				</div>
				<div className='table__item--col head'>
					{dict.letters.recipient.toUpperCase()}
				</div>
				<div className='table__item--col head'>
					{dict.letters.initiator.toUpperCase()}
				</div>
				<div className='table__item--col head'>
					{dict.letters.table.version.toUpperCase()}&nbsp;
					<TooltipIcon 
						tooltipText={ dict.letters.table.versionTooltip } 
					/>
				</div>
				<div className='table__item--col head'>
					{dict.letters.table.category.toUpperCase()}
				</div>
				<div className='table__item--col head'>
					{dict.letters.table.template.toUpperCase()}
				</div>
			</div>
		</div>
	);
};

export default memo(LettersContainerHeader);